import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { fmt } from "@/lib/status";
import { useReauthCall } from "@/lib/reauth";

export function ManagePinDialog({ open, onOpenChange }) {
  const [st, setSt] = useState(null);
  const [pin, setPin] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const save = useReauthCall("post", "/me/verification-pin");
  useEffect(() => { if (open) { setPin(""); setConfirm(""); api.get("/me/verification-pin").then((r) => setSt(r.data)).catch(() => {}); } }, [open]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await save({ pin, confirm }); toast.success("Verification PIN saved"); onOpenChange(false); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const digits = (f) => (e) => f(e.target.value.replace(/\D/g, "").slice(0, 6));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="manage-pin-dialog">
        <DialogHeader><DialogTitle>Manage Verification PIN</DialogTitle>
          <DialogDescription>Used only to confirm consent verification. You will re-enter your sign-in credentials first. Administrators can reset it but can never see it.</DialogDescription></DialogHeader>
        {st && <p className="text-sm" data-testid="manage-pin-status">
          {st.has_pin ? `PIN set ${fmt(st.set_at)}` : st.reset_required ? "PIN was reset - create a new one" : "No PIN yet"}
          {st.locked && <span className="text-red-700"> - locked until {fmt(st.locked_until)}</span>}
          <span className="block text-xs text-slate-500">Organization method: {st.method}{st.method !== "pin" && " (PIN not currently required)"}</span></p>}
        {st && !st.is_provider ? <p className="text-sm text-slate-500">Only providers use a verification PIN.</p> : (
          <form onSubmit={submit} className="space-y-3">
            <Input type="password" inputMode="numeric" autoComplete="new-password" value={pin} onChange={digits(setPin)} placeholder="New 6-digit PIN" data-testid="manage-pin-new" />
            <Input type="password" inputMode="numeric" autoComplete="new-password" value={confirm} onChange={digits(setConfirm)} placeholder="Confirm PIN" data-testid="manage-pin-confirm" />
            <p className="text-xs text-slate-500">Avoid repeated digits, sequences and your workstation lock PIN.</p>
            <Button type="submit" disabled={busy || pin.length !== 6 || pin !== confirm} data-testid="manage-pin-save">{st?.has_pin ? "Change PIN" : "Create PIN"}</Button>
          </form>)}
      </DialogContent>
    </Dialog>
  );
}
